import { render, staticRenderFns } from "./complainView.vue?vue&type=template&id=02a13c5b&scoped=true"
import script from "./complainView.vue?vue&type=script&lang=js"
export * from "./complainView.vue?vue&type=script&lang=js"
import style0 from "./complainView.vue?vue&type=style&index=0&id=02a13c5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a13c5b",
  null
  
)

export default component.exports